// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"154":"c4a3ba9b","775":"20902857"}[chunkId] + ".css";
};